<div class="row row-nowrap" [style.textAlign]="'left'">
    <div class="col">
        <p class="ui-label-m text-ellipsis"
        [innerHTML]="option.name | highlight:highlightPhrase"></p>
        <p class="ui-label-s text-ellipsis">{{option.description}}</p>
    </div>
</div>